import {
  Avatar,
  Box,
  Button,
  Flex,
  HStack,
  Image,
  Input,
  InputGroup,
  InputRightElement,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import moment from "moment";
import { ChangeEvent, useEffect, useState } from "react";
import { RiSearch2Line } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import AdminDashboardHeader from "../../../components/admin/AdminHeader";
import AdminSidebar from "../../../components/admin/AdminSidebar";
import Loading from "../../../components/common/Loading";
import empty from "../../../img/emptystate1.svg";
import AdminHelpers from "../../../services/admin/admin.service";
import Adminroutes from "../routes";
const Alumni = () => {
  const [loading, setLoading] = useState(false);
  const [alumnis, setAlumnis] = useState([]);
  const [filteredAlumnis, setFilteredAlumnis] = useState<any[]>([]);
  const [isSearchEmpty, setIsSearchEmpty] = useState(false);
  const navigate = useNavigate();

  // useEffect(() => {
  //   try {
  //     AdminHelpers.getAlumni().then((res) => {
  //       setAlumnis(res.data.data);
  //       setFilteredAlumnis(res.data.data);
  //     });
  //   } catch (err) {
  //     throw err;
  //   } finally {
  //     setLoading(false);
  //   }
  // }, []);

  useEffect(() => {
    const fetchAlumni = async () => {
      setLoading(true); // Start loading
      try {
        const res = await AdminHelpers.getAlumni();
        setAlumnis(res.data.data);
        setFilteredAlumnis(res.data.data);
      } catch (err) {
        console.error("Failed to fetch alumni data:", err); // Handle error appropriately
      } finally {
        setLoading(false); // Stop loading after data fetch is complete or failed
      }
    };

    fetchAlumni();
  }, []);

  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    const searchTerm = event.target.value.toLowerCase();
    if (!searchTerm) {
      setFilteredAlumnis(alumnis);
    } else {
      if (alumnis) {
        const filtered = alumnis.filter((each: any) =>
          each.model.name.toLowerCase().includes(searchTerm)
        );
        setFilteredAlumnis(filtered);
        if (filtered && filtered.length > 0) setIsSearchEmpty(false);
        else setIsSearchEmpty(true);
      }
    }
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Flex
          minHeight={"100vh"}
          height={"auto"}
          boxSizing="border-box"
          maxWidth={"100hw"}
        >
          <Box
            width={["4rem", "4rem", "4rem", "25%"]}
            position="relative"
            top="0"
            left="0"
            zIndex="100"
          >
            <AdminSidebar />
          </Box>
          <Box width="100%">
            <AdminDashboardHeader />
            <Box
              pt="30px"
              pb="40px"
              px={["20px", "30px"]}
              width={"100%"}
              bg="#F9F8F8"
              height={"100%"}
              minHeight={"95vh"}
              maxHeight={"95vh"}
              overflowY={"scroll"}
            >
              <Flex
                justifyContent="space-between"
                alignItems="center"
                py="26px"
              >
                <Box color="#2B2B2B" fontWeight="800" fontSize="27px">
                  Alumni
                </Box>
                <HStack>
                  <Button
                    colorScheme="red"
                    p="7px"
                    borderRadius={"2px"}
                    fontSize="14px"
                    onClick={() => navigate(Adminroutes.NewAlumni)}
                  >
                    CREATE ALUMNI
                  </Button>
                </HStack>
              </Flex>
              <Flex py="15px" justifyContent="">
                <InputGroup
                  color="brand.subtitle"
                  bg="white"
                  width={["100%", "100%", "50%", "30%"]}
                >
                  <Input
                    height="40px"
                    placeholder="Search alumni by name"
                    fontSize={12}
                    size="sm"
                    onChange={(e) => handleSearchChange(e)}
                  />
                  <InputRightElement
                    pointerEvents="none"
                    children={<RiSearch2Line color="red" size="0.9rem" />}
                  />
                </InputGroup>
              </Flex>
              {filteredAlumnis.length > 0 ? (
                <Box width={"100%"}>
                  <TableContainer>
                    <Table size={"sm"}>
                      <Thead>
                        <Tr>
                          <Th>Full name</Th>
                          <Th>Course Code</Th>
                          <Th>Gender</Th>
                          <Th>Phone</Th>
                          <Th>Address</Th>
                          <Th>Admission Date</Th>
                          <Th>Graduation Date</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {filteredAlumnis?.map((each: any, i: number) => {
                          return (
                            <Tr bg="white" borderWidth="1px" key={i}>
                              <Td>
                                <HStack>
                                  <Avatar
                                    name={each.model.name}
                                    src="https://bit.ly/broken-link"
                                    size={"md"}
                                  />
                                  <Text>{each.model.name}</Text>
                                </HStack>
                              </Td>
                              <Td>{each.model.course_code}</Td>
                              <Td>{each.model.gender}</Td>
                              <Td>{each.model.phone}</Td>
                              <Td>{each.model.address}</Td>
                              <Td>
                                {moment(each.model.admission_date).format(
                                  "MMMM Do YYYY, h:mm:ss a"
                                )}
                              </Td>
                              <Td>
                                {moment(each.model.graduation_date).format(
                                  "MMMM Do YYYY, h:mm:ss a"
                                )}
                              </Td>
                            </Tr>
                          );
                        })}
                      </Tbody>
                    </Table>
                  </TableContainer>
                </Box>
              ) : (
                <Box
                  width="70%"
                  mb="10px"
                  mx="auto"
                  pt="40px"
                  pb="70px"
                  rounded="lg"
                >
                  <Box>
                    <Box mx="auto" width={"100px"} height="150px">
                      <Image src={empty} />
                    </Box>
                    <Text
                      textAlign="center"
                      fontWeight="600"
                      fontSize="24px"
                      color="#353535"
                    >
                      No Alumni
                    </Text>
                    <Text color="#353535" textAlign="center" fontSize="14px">
                      Alumni would be added here once you create them or when a
                      trainee completes a course
                    </Text>
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
        </Flex>
      )}
    </>
  );
};

export default Alumni;
